import {CallProgramme, InterestedPartner, Programme} from '@/features/partners/model/types';
import {BaseEntity} from './common';

export interface Call extends BaseEntity {
  title: string;
  description: string;
  amount: number;
  currency: string;
  deadline: string;
  status: CallStatus;
  categories: string[];
  requirements: string[];
  is_call_bookmarked: boolean;
  is_call_declared_interest: boolean;
  interested_partners?: InterestedPartner[];
  is_new: boolean;
  matchPercentage: number;
  comments: number;
  ideas: number;
  tags: string[];
  max_score?: string | false; // sometimes "70" as string, sometimes boolean false
  programmes?: Programme[];
  programme?: CallProgramme;
}

export enum CallStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
  DRAFT = 'draft',
  SUSPENDED = 'suspended',
}

export const createDefaultCall = (): Partial<Call> => ({
  title: '',
  description: '',
  amount: 0,
  currency: 'EUR',
  deadline: new Date().toISOString(),
  status: CallStatus.DRAFT,
  categories: [],
  requirements: [],
  matchPercentage: 0,
  comments: 0,
  ideas: 0,
  tags: [],
});

// Type guard to check if object is a valid Call
export const isValidCall = (obj: any): obj is Call => {
  return (
    obj &&
    typeof obj.id === 'string' &&
    typeof obj.title === 'string' &&
    typeof obj.description === 'string' &&
    typeof obj.amount === 'number' &&
    typeof obj.currency === 'string' &&
    typeof obj.deadline === 'string' &&
    Object.values(CallStatus).includes(obj.status) &&
    Array.isArray(obj.categories) &&
    Array.isArray(obj.requirements) &&
    typeof obj.interestedPartners === 'object' &&
    typeof obj.matchPercentage === 'number' &&
    typeof obj.comments === 'number' &&
    typeof obj.ideas === 'number' &&
    Array.isArray(obj.tags)
  );
};
